import React from "react";
import Drawer from "@mui/material/Drawer";
import Toolbar from "@mui/material/Toolbar";

import { sideBarNavWidth, sideBarNavMiniWidth } from "../../../assets/theme/generalTheme";

const drawerWidth = sideBarNavWidth;
const drawerMiniWidth = sideBarNavMiniWidth;

interface Props {
  openSideBarNav: boolean;
  children: any;
  handleDrawerToggle?: () => void;
  handleOpenSideBarNavClicked: () => void;
}

const SideBarNav = React.memo(({ openSideBarNav, children }: Props) => {
  return (
    <div>
      <Drawer
        transitionDuration={400}
        variant="permanent"
        PaperProps={{
          elevation: 3,
          sx: [
            (theme) => ({
              overflowX: "hidden",
              backgroundColor: theme.palette.background.default,
              backgroundImage: "none",
              borderRight: `1px solid ${theme.palette.background.paper}`,
              transition: theme.transitions.create("width", {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
              }),
            }),
            openSideBarNav ? { width: drawerWidth } : { width: drawerMiniWidth },
            !openSideBarNav && {
              "&:hover": {
                width: drawerWidth,
              },
            },
          ],
        }}
        sx={[
          (theme) => ({
            flexShrink: 0,
            backgroundColor: "blue",
            transition: theme.transitions.create("width", {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
          }),
          openSideBarNav ? { width: drawerWidth } : { width: drawerMiniWidth },
          !openSideBarNav && {
            "&:hover": {
              width: drawerWidth,
            },
          },
        ]}
      >
        <Toolbar />
        <div>{children}</div>
      </Drawer>
    </div>
  );
});
SideBarNav.displayName = "SideBarNav";
export default SideBarNav;
